import React from 'react';
import './auth.scss';
import logo from '../../assets/logo/Logo1.png';
import { Button, Form, Input } from 'antd';
import { Col, Row } from 'antd';
import { ALERT_TYPES, LoginFields, lOGIN_ROUTE } from '../../constants';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { userNewPasswordRequest } from '../../redux/slicers/user';
import { toastAlert } from '../../services/utils';

function ResetPass() {
  const [form] = Form.useForm();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { password } = LoginFields.fields;

  const navigate = useNavigate();
  const handleSubmit = () => {
    const values = form.getFieldsValue();
    const payload = { newPassword: values.newPassword, resetString: id };
    dispatch(
      userNewPasswordRequest({
        payloadData: payload,
        responseCallback: (status, res) => {
          if (status && res) {
            toastAlert(res.msg, ALERT_TYPES.success);
            navigate(lOGIN_ROUTE);
          } else if (!status && res) {
            toastAlert(res.msg, ALERT_TYPES.error);
          }
        }
      })
    );
  };
  return (
    <div className="login-container">
      <Row align={'middle'} className="loginWrapper" justify="center">
        <Col xs={24} lg={13}>
          <div className="loginLogoWrapper">
            <img src={logo} className="logo-login" />
            <div className="title-cont">
              <p style={{ fontWeight: 'bold' }}>Site</p>
              &nbsp;
              <p style={{ fontWeight: 'lighter' }}>Circles</p>
            </div>
            <p className="tagline">Please enter your new password below.</p>
          </div>
          <Form className="form-login" form={form} onFinish={handleSubmit}>
            <Form.Item name={password.new_title} rules={password.rules}>
              <Input
                type={password.type}
                placeholder={password.new_label}
                className="login-input"
              />
            </Form.Item>
            <Form.Item name={password.repeat_title} rules={password.rules}>
              <Input
                type={password.type}
                placeholder={password.repeat_label}
                className="login-input"
              />
            </Form.Item>

            <div className="login-button-wrapper-forget">
              <div className="btn-cont-send-btn">
                <Button
                  size="large"
                  htmlType="submit"
                  className="send-pass-btn"
                >
                  Save my new password
                </Button>
              </div>
            </div>
          </Form>
        </Col>
        <Col xs={24} lg={13}>
          <div className="label-wrapper-forgetpass">
            <Link className="frgt-pass-labels">What is SiteCircles?</Link>
            <Link className="frgt-pass-labels">Contact Us</Link>
            <Link className="frgt-pass-labels">Pricing</Link>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default ResetPass;
